import { FeeType } from "./FeeType";
import { IFee, IFeeMap } from "../models/IFee";

function normalizeFeeName(feeName: FeeType): string {
    const feeList = Object.values(FeeType);
    if (feeList.includes(feeName)) {
       return feeName;
    }
    return feeList.find(name => feeName.match(name));
}

export function mapResponseToFees(feeList: IFee[]): IFeeMap {
    const feeMapResult: IFeeMap = {};
    return feeList.reduce((acc, fee) => {
        acc[normalizeFeeName(fee.Name)] = fee.Amount;
        return acc;
    }, feeMapResult);
}

export function sumFees(fees: FeeType[], feeData: IFeeMap): number {
    const sum = fees.reduce((acc, fee) => {
        return acc + (feeData[fee] || 0);
    }, 0);
    return sum;
}

export function calculateFees(price: number, feeData: IFeeMap): IFeeMap {
    const calculatedFees = { ...feeData };
    calculatedFees[FeeType.POINTS] = 100 - price;
    calculatedFees[FeeType.TITLE_FEES] = sumFees([FeeType.RECORDING, FeeType.TITLE_SERVICES, FeeType.CLOSING, FeeType.TITLE_ENDORSEMENT], calculatedFees);
    calculatedFees[FeeType.TOTAL_THIRD_PARTY] = sumFees([FeeType.TITLE_FEES, FeeType.CREDIT_REPORT, FeeType.APPRAISAL, FeeType.INSPECTION, FeeType.FINAL_REINSPECTION], calculatedFees);
    calculatedFees[FeeType.TOTAL_LENDER_FEES] = sumFees([FeeType.LOAN_ORIGINATION, FeeType.PROCESSING, FeeType.POINTS], calculatedFees);
    return calculatedFees;
}